import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const ProfessionalHeadshot = () => {
  const navigate = useNavigate();
  const contactActions = [
    {
      icon: 'Mail',
      label: 'Email',
      action: 'mailto:contact.dishantpatel@gmail.com',
      color: 'text-primary'
    },
    {
      icon: 'Phone',
      label: 'Call',
      action: 'tel:+91-8141475777',
      color: 'text-success'
    },
    {
      icon: 'MessageCircle',
      label: 'Message',
      action: '#contact',
      color: 'text-accent'
    },
    {
      icon: 'Calendar',
      label: 'Schedule',
      action: 'https://calendly.com/contact-dishantpatel',
      color: 'text-warning'
    }
  ];

  const handleContactAction = (action) => {
    if (action.startsWith('mailto:') || action.startsWith('tel:')) {
      window.location.href = action;
    } else if (action.startsWith('http')) {
      window.open(action, '_blank');
    } else {
      document.querySelector(action)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-surface rounded-lg p-6 shadow-md border border-border">
      {/* Professional Photo */}
      <div className="relative mb-6">
        <div className="w-48 h-48 mx-auto rounded-full overflow-hidden border-4 border-primary/20">
          <Image
            src="/assets/images/IMG_4325.png"
            alt="Dishant Madariya - Full Stack Developer"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
          <div className="bg-success text-white px-2 py-1 sm:px-3 rounded-full text-xs sm:text-sm font-medium flex items-center whitespace-nowrap">
            <div className="w-2 h-2 bg-white rounded-full mr-1.5 sm:mr-2 animate-pulse"></div>
            Available for Work
          </div>
        </div>
      </div>

      {/* Basic Info */}
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-text-primary mb-2">Dishant Madariya</h2>
        <p className="text-lg text-primary font-medium mb-1">Senior MERN Stack Developer | Technical Consultant | Solution Architect</p>
        <p className="text-text-secondary mb-3">Surat, India</p>
        
        <div className="flex items-center justify-center space-x-4 text-sm text-text-secondary">
          <div className="flex items-center">
            <Icon name="MapPin" size={16} className="mr-1" />
            Remote & Local Friendly
          </div>
          <div className="flex items-center">
            <Icon name="Clock" size={16} className="mr-1" />
            IST Timezone
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="text-center p-3 bg-muted rounded-lg">
          <div className="text-2xl font-bold text-primary">4.5+</div>
          <div className="text-sm text-text-secondary">Years Experience</div>
        </div>
        <div className="text-center p-3 bg-muted rounded-lg">
          <div className="text-2xl font-bold text-success">30+</div>
          <div className="text-sm text-text-secondary">Projects Completed</div>
        </div>
        <div className="text-center p-3 bg-muted rounded-lg">
          <div className="text-2xl font-bold text-accent">10+</div>
          <div className="text-sm text-text-secondary">Technologies</div>
        </div>
        <div className="text-center p-3 bg-muted rounded-lg">
          <div className="text-2xl font-bold text-warning">99%</div>
          <div className="text-sm text-text-secondary">Client Satisfaction</div>
        </div>
      </div>

      {/* Contact Actions */}
      <div>
        <h3 className="text-sm font-semibold text-text-primary mb-3">Quick Contact</h3>
        <div className="grid grid-cols-2 sm:grid-cols-1 gap-2">
          {contactActions.map((contact, index) => (
            <Button
              key={index}
              variant="ghost"
              className="w-full justify-start text-xs sm:text-sm"
              onClick={() => handleContactAction(contact.action)}
            >
              <Icon name={contact.icon} size={16} className={`mr-2 sm:mr-3 ${contact.color}`} />
              <span className="text-text-primary">{contact.label}</span>
            </Button>
          ))}
        </div>
      </div>

      {/* Social Links */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex justify-center space-x-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => window.open('https://github.com/DishantMadariya', '_blank')}
            title="GitHub Profile"
          >
            <Icon name="Github" size={20} />
          </Button>
          {/* <Button
            variant="ghost"
            size="icon"
            onClick={() => window.open('https://linkedin.com/in/dishantmadariya', '_blank')}
            title="LinkedIn Profile"
          >
            <Icon name="Linkedin" size={20} />
          </Button> */}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => window.open('https://twitter.com/dishant_patel14', '_blank')}
            title="Twitter Profile"
          >
            <Icon name="Twitter" size={20} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/blog')}
            title="Personal Blog"
          >
            <Icon name="Globe" size={20} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalHeadshot;
